export default __webpack_public_path__ + "static/demolition-concrete_removal-c8ce0dadfce8d3d820a5e7bc374c1f34.png";